import { atom } from 'jotai';
import { $CurrentHashtagId } from '@hashtag/shared/current-hashtag';
import { $HashtagPopularPost, $HashtagRecentPost } from 'shared/atoms';

export const $CurrentHashtagPopularPosts = atom((get) => {
  const hashtagId = get($CurrentHashtagId);
  return get($HashtagPopularPost(hashtagId));
});

export const $CurrentHashtagRecentPosts = atom((get) => {
  const hashtagId = get($CurrentHashtagId);
  return get($HashtagRecentPost(hashtagId));
});
